import {Component} from '@angular/core';
import {
  ArticleBodyDirective,
  ArticleTitleDirective,
  PolicyArticleComponent
} from "projects/soko-console-web-v2/src/app/features/support/policies/policy-article/policy-article.component";

@Component({
  selector: 'app-pay-out-policy-and-frequency-article',
  standalone: true,
  imports: [
    PolicyArticleComponent, ArticleTitleDirective, ArticleBodyDirective
  ],
  styleUrl: './styles/support-policy-articles-common.scss',
  template: `
    <app-policy-article>
      <span articleTitle>Pay-out policy and frequency</span>
      <div articleBody class="body-1-regular-1">

        <section>
          <div class="heading">Single lease per point-of-sale</div>
          <div>Tenant pay-outs are generally scheduled 3 times a week, conducted on a Monday, Wednesday and Friday.
          </div>
          <div>Pay-outs generally relate to the following transaction days:</div>
            <ul>
              <li>Monday: Pay out Thursday – Friday transactions</li>
              <li>Wednesday: Pay out Saturday – Monday transactions</li>
              <li>Friday: Pay out Tuesday – Wednesday transactions</li>
            </ul>
            <div>
              Tenant pay-outs are affected by public holidays. Necessary communication will be shared with landlords
              prior to these events to communicate adjusted pay-out schedules during these times. The responsibility
              lies with the landlords to inform all affected tenants.
            </div>

        </section>

        <section>
          <div class="heading">Multiple leases per point-of-sale</div>
          <div>Tenant pay-outs are generally scheduled twice a month, conducted on a Monday, Wednesday or Friday.</div>
            <ul>
              <li>
                1st pay-out: Within 2 working days after the 15th of each month, including transactions from the 1st to
                the 15th of the month.
              </li>
              <li>
                2nd pay-out: Within 2 working days after the last day of the month, including transactions from the 16th
                up to the last day of the month.
              </li>
            </ul>
        </section>

      </div>
    </app-policy-article>
  `
})
export class PayOutPolicyAndFrequencyArticleComponent {

}
